const registerBaseAlpineData = (Alpine) => {
  if (window.__mealflowBaseAlpineRegistered) return;

  Alpine.data('themeData', () => ({
    darkMode: localStorage.getItem('theme') === 'theme-dark',

    init() {
      this.applyTheme();
      this.watchSystemTheme();
    },

    applyTheme() {
      const theme = this.darkMode ? 'theme-dark' : 'theme-light';
      const daisyTheme = this.darkMode ? 'mealflow-dark' : 'mealflow-light';

      document.documentElement.classList.remove('theme-light', 'theme-dark');
      document.documentElement.classList.add(theme);
      document.documentElement.dataset.theme = daisyTheme;
      localStorage.setItem('theme', theme);
    },

    toggleTheme() {
      this.darkMode = !this.darkMode;
      this.applyTheme();
    },

    watchSystemTheme() {
      window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (event) => {
        if (!localStorage.getItem('theme')) {
          this.darkMode = event.matches;
          this.applyTheme();
        }
      });
    }
  }));

  window.__mealflowBaseAlpineRegistered = true;
};

export const initializeAlpineRuntime = (Alpine) => {
  window.Alpine = Alpine;
  registerBaseAlpineData(Alpine);
};

export const startAlpineRuntime = () => {
  if (window.__alpineStarted || !window.Alpine) return;

  window.Alpine.start();
  window.__alpineStarted = true;
};
